import { atom } from 'recoil';
import { DefaultTheme } from '../../assets/styles/theme';
import defaultLogo from '../../assets/images/default-logo.png'

const isLoadingState = atom({
    key: 'isLoadingState',
    default: false,
})

const loadingProgressState = atom({
    key: 'loadingProgressState',
    default: null,
})

const homeLogoState = atom({
    key: 'homeLogoState',
    default: defaultLogo,
})

const homeBannerState = atom({
    key: 'homeBannerState',
    default: null,
})

const themeState = atom({
    key: 'themeState',
    default: {
        primary: DefaultTheme.primary,
        secondary1: DefaultTheme.secondary1,
        secondary2: DefaultTheme.secondary2
    },
})

const themeColorState = atom({
    key: 'themeColorState',
    default: 'red',
})

const isUpdateUserAfterSaveState = atom({
    key: 'isUpdateUserAfterSaveState',
    default: false,
})

const toggleLoginPopUpState = atom({
    key: 'toggleLoginPopUpState',
    default: false,
})

const isAILoadingState = atom({
    key: 'isAILoadingState',
    default: false,
})

const isGetJobRecommendAIState = atom({
    key: 'isGetJobRecommendAIState',
    default: false,
})

export {
    isLoadingState,
    isUpdateUserAfterSaveState,
    loadingProgressState,
    themeState,
    themeColorState,
    homeLogoState,
    homeBannerState,
    toggleLoginPopUpState,
    isAILoadingState,
    isGetJobRecommendAIState
}